function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 520,
  height: 220,
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20,
  width: 480,
  height: 180,
  rx: 18,
  fill: "#F5F2FF"
});
var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 380,
  cy: 110,
  rx: 120,
  ry: 70,
  fill: "#EEE8FF"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 240,
  y: 55,
  width: 140,
  height: 95,
  rx: 8,
  fill: "#2F356D"
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 252,
  y: 67,
  width: 116,
  height: 70,
  rx: 4,
  fill: "#FFFFFF"
});
var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 225,
  y: 150,
  width: 170,
  height: 12,
  rx: 6,
  fill: "#444C8B"
});
var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 280,
  cy: 85,
  r: 14,
  fill: "#7C5CFF"
});
var _ref9 = /*#__PURE__*/React.createElement("text", {
  x: 275,
  y: 91,
  fontSize: 18,
  fill: "white"
}, "\u20B9");
var _ref10 = /*#__PURE__*/React.createElement("line", {
  x1: 305,
  y1: 80,
  x2: 350,
  y2: 80,
  stroke: "#CFC7FF",
  strokeWidth: 4
});
var _ref11 = /*#__PURE__*/React.createElement("line", {
  x1: 305,
  y1: 95,
  x2: 345,
  y2: 95,
  stroke: "#CFC7FF",
  strokeWidth: 4
});
var _ref12 = /*#__PURE__*/React.createElement("line", {
  x1: 305,
  y1: 110,
  x2: 338,
  y2: 110,
  stroke: "#CFC7FF",
  strokeWidth: 4
});
var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 205,
  y: 95,
  width: 38,
  height: 55,
  rx: 4,
  fill: "#5B62A5"
});
var _ref14 = /*#__PURE__*/React.createElement("g", {
  fill: "#D9DCFF"
}, /*#__PURE__*/React.createElement("rect", {
  x: 212,
  y: 103,
  width: 7,
  height: 7
}), /*#__PURE__*/React.createElement("rect", {
  x: 223,
  y: 103,
  width: 7,
  height: 7
}), /*#__PURE__*/React.createElement("rect", {
  x: 212,
  y: 115,
  width: 7,
  height: 7
}), /*#__PURE__*/React.createElement("rect", {
  x: 223,
  y: 115,
  width: 7,
  height: 7
}), /*#__PURE__*/React.createElement("rect", {
  x: 212,
  y: 127,
  width: 7,
  height: 7
}), /*#__PURE__*/React.createElement("rect", {
  x: 223,
  y: 127,
  width: 7,
  height: 7
}));
var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 405,
  y: 75,
  width: 55,
  height: 80,
  rx: 4,
  fill: "#FFFFFF",
  stroke: "#D9D2FF"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M418 130 L430 118 L438 125 L450 100",
  stroke: "#8B7CFF",
  strokeWidth: 3,
  fill: "none"
});
var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 445,
  cy: 165,
  rx: 18,
  ry: 6,
  fill: "#F7C84A"
});
var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 427,
  y: 145,
  width: 36,
  height: 20,
  fill: "#F7C84A"
});
var _ref19 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 445,
  cy: 145,
  rx: 18,
  ry: 6,
  fill: "#FFD86E"
});
var _ref20 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 470,
  cy: 170,
  rx: 15,
  ry: 5,
  fill: "#F0B52E"
});
var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 455,
  y: 153,
  width: 30,
  height: 17,
  fill: "#F0B52E"
});
var _ref22 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 470,
  cy: 153,
  rx: 15,
  ry: 5,
  fill: "#FFD86E"
});
var _ref23 = /*#__PURE__*/React.createElement("text", {
  x: 465,
  y: 167,
  fontSize: 12,
  fill: "#A46A00"
}, "\u20B9");
var _ref24 = /*#__PURE__*/React.createElement("g", {
  fill: "#D8D1FF"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 485,
  cy: 45,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 475,
  cy: 55,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 465,
  cy: 45,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 485,
  cy: 65,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 475,
  cy: 75,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 465,
  cy: 65,
  r: 2
}));
function SvgPayrollautomation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 520,
    height: 220,
    viewBox: "0 0 520 220",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrollautomation);
export default __webpack_public_path__ + "static/media/payrollautomation.2af4c1b4.svg";
export { ForwardRef as ReactComponent };